export const GET_LATEST_INSURANCES_ERROR = 'GET_LATEST_INSURANCES_ERROR';
export const GET_LATEST_INSURANCES_SUCCESS = 'GET_LATEST_INSURANCES_SUCCESS';
export const GET_LATEST_INSURANCES_REQUEST = 'GET_LATEST_INSURANCES_REQUEST';